import { createRoundedRectPolygon } from './shapes.js';
export const createSquareHolePolygon = (hole)=>{
    const { $absCoords: center, sideLength, cornerRadius } = hole;
    return createRoundedRectPolygon({
        center,
        width: sideLength,
        height: sideLength,
        cornerRadius
    });
};

//# sourceMappingURL=square-hole.js.map